<div class="container-fluid">
    <mat-radio-group [(ngModel)]="valueText" (change)="onRadioChange($event)">
        <mat-radio-button class="d-block" [disabled]="summaryMode" value="Yes"
            [attr.data-test-value]="true">Yes</mat-radio-button>
        <mat-radio-button class="d-block" [disabled]="summaryMode" value="No"
            [attr.data-test-value]="false">No</mat-radio-button>
    </mat-radio-group>
    <mat-error *ngIf="question.invalid">required</mat-error>
</div>